"use strict";

export default () => input => {
  if (!input) {
    return input;
  }
  return angular.element(input).text().replace(/(\n|\r)/gm, "").replace(/\s{2,}/gm, " ");
};
